<div class="bg-white shadow border-radius">
	<div *ngIf="tags.length" class="px-4 py-2">
		<div class="row">
			<span *ngFor="let tag of tags; let last = last" class="d-table-cell align-middle my-3 ml-3">
				<span class="main-green-bg py-2 pl-2 pr-1 rounded text-white">
					<span class="ml-1 mr-3">{{tag.customer_name}}</span>
					<a class="px-2 py-1 light-green-bg pointer rounded" (click)="closeExpandedCustomer(tag)">
						<i class="fa fa-times font-size-12 glyphicon-white d-table-cell align-middle" style="font-size: 0.9rem;"></i>
					</a>
				</span>
				<span *ngIf="!last" class="vl ml-3"></span>
			</span>
		</div>
	</div>
	<div class="row m-0 px-4 py-5">
		<div class="col-xl-6 col-md-12 order-md-2 order-xl-1">
			<h6 class="px-2 text-muted"
				*ngIf="usersService.hasAccessFunction('analytics_source_comparison') && activeAnalyticsSource">
				Current (selected source: {{activeAnalyticsSource}})
			</h6>
			<app-info-box *ngIf="sitesAnalytics"
				[ioTAhDevices]="sitesAnalytics.ioTAhDevices"
				[chargLinkDevices]="sitesAnalytics.chargLinkDevices"
				[battLinkDevices]="sitesAnalytics.battLinkDevices"
				[iotemeterDevices]="sitesAnalytics.iotemeterDevices"
				[deviceTypeFilterSelected]="deviceTypeFilterSelected"
			></app-info-box>
		</div>
		<div class="col-xl-6 col-md-12 order-md-1 order-xl-2">
			<div class="mapbox-widget">
				<app-mapbox-search
					class="border-radius main-blue-border"
					dotsType="sites"
					[latitude]="initLat"
					[longitude]="initLong"
					zoom="2.5"
					[dots]="verifiedSites"
				></app-mapbox-search>
			</div>
		</div>
	</div>

	<!-- Analytics-source comparison diagnostic: the new tables, for comparison against the box above,
	     which follows the source selected on the Admin Actions page. See
	     SitesMapComponent.loadTableComparison. -->
	<div class="row m-0 px-4 pb-5" *ngIf="usersService.hasAccessFunction('analytics_source_comparison')">
		<div class="col-xl-6 col-md-12">
			<h6 class="px-2 text-muted">New (source: new table, device_analytics_summary)</h6>
			<app-info-box *ngIf="newTableAnalytics"
				[ioTAhDevices]="newTableAnalytics.ioTAhDevices"
				[chargLinkDevices]="newTableAnalytics.chargLinkDevices"
				[battLinkDevices]="newTableAnalytics.battLinkDevices"
				[iotemeterDevices]="newTableAnalytics.iotemeterDevices"
				[deviceTypeFilterSelected]="deviceTypeFilterSelected"
			></app-info-box>
		</div>
	</div>
</div>
